export default {"src":"/_next/static/media/report-icon.2f749c64.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};